export namespace IBarrier {
  export const ACTION = 'gate_MK';
  export enum Commands {
    GetList = 'LIST',
    OpenBarrier = 'OPEN',
    GetActionsListing = 'RptCamerasOpen',
    HistoryLog = 'HistoryLog',
    GateEventsLog = 'GateEventsLog',
    TabloReload = 'TabloReload',
    TabloLog = 'TabloLog',
    GateLog = 'GateLog',
  }

  export interface IBarrierItem {
    id: number;
    name: string;
    typeName: string;
  }

  export interface IBarrierAction {
    camName: string;
    dateEvent: string;
    dateRus: string;
    eventName: string;
    persName: string;
  }
}
